/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
import axios from "axios";
import router from "../router";
import store from "../store/index";
import Login from "@/services/login";

const defaultApi = () => {
  const Api = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL
      ? process.env.VUE_APP_BASE_URL
      : "http://" + location.hostname + ":3030", // prod
    // baseURL: 'http://182.73.102.92:3030', // sbe local
    // baseURL: 'http://65.2.114.148:3030' // Development-2 Server
    // baseURL: 'http://localhost:3040', // dev
    // baseURL: 'http://api.eaglesunscada.com:3030', // production
    // baseURL: 'https://apis.eaglesunscada.com' // production
    // baseURL: 'http://35.154.27.182:3040' // development
    // baseURL: 'https://api.emscada.com' // development
  });

  // Default timeout set to 30s
  Api.defaults.timeout = 30000;

  // LOGOUT WHEN TOKEN EXPIRES
  let isLogoutInProgress = false;
  window.vueRouterHook = async (path) => {
    const token = store.getters.getGeneralState('token')
    if (token) {
      try {
        const payload = {
          token,
        };
        await Login.logoutUser(payload);
        store.dispatch("resetState");
        localStorage.clear();
        router.push(path);
      } catch (err) {
        console.log(err, "Logout Error");
      }
    } else {
      store.dispatch("resetState");
      localStorage.clear();
      router.push(path);
    }
  };

  Api.interceptors.request.use(
    function (request) {
      if (store.getters.getGeneralState('token') != null) {
        request.headers.Authorization =
          "Bearer " + store.getters.getGeneralState('token');
      }
      return request;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  Api.interceptors.response.use(
    function (res) {
      return res;
    },
    async (error) => {
      // Showing snackbar when there is a failed response
      let payload = {
        icon: "error",
      };
      if (error.response && error.response.status === 403) {
        if (!isLogoutInProgress) {
          try {
            isLogoutInProgress = true;
            window.vueRouterHook("/login");
            payload["message"] = "Session has expired";
          } catch (err) {
            console.log(err, 'Logout error');
          } finally {
            isLogoutInProgress = false; // Reset the flag after logout process
          }
        }
      } else {
        // Handle other error scenarios
        if (
          !("message" in error.response.data) &&
          !("error" in error.response.data)
        ) {
          payload["header"] = "Unknown Error";
        } else if (error.response.data && error.response.data.message) {
          payload["header"] = "Error";
          payload["message"] =
            error.response.data && error.response.data.message
              ? error.response.data.message
              : error.response.data;
        } else if (error.response.data && error.response.data.error) {
          payload["header"] = "Error";
          payload["message"] =
            error.response.data && error.response.data.error
              ? error.response.data.error
              : error.response.data;
        } else {
          payload["header"] = error.message;
        }
      }
      store.commit("SET_SHOW_SNACKBAR", true);
      store.commit("SET_SNACKBAR_CONTENT", payload);
    }
  );
  return Api;
};

const requestToken = axios.CancelToken;
let cancelSource = requestToken.source();

export const refreshToken = () => {
  cancelSource = requestToken.source();
};

export const cancelAllRequests = () => {
  cancelSource.cancel();
};

export const Api = () => {
  return {
    post: (...params) => {
      return defaultApi().post(...params, {
        cancelToken: cancelSource.token
      });
    },
    patch: (...params) => {
      return defaultApi().patch(...params, {
        cancelToken: cancelSource.token
      });
    },
    get: (...params) => {
      return defaultApi().get(...params, {
        cancelToken: cancelSource.token
      });
    },
    delete: (...params) => {
      return defaultApi().delete(...params, {
        cancelToken: cancelSource.token,
      });
    },
    request: (params) => {
      return defaultApi().request(
        Object.assign(params, {
          cancelToken: cancelSource.token
        })
      );
    },
    put: (...params) => {
      return defaultApi().put(...params, {
        cancelToken: cancelSource.token
      });
    },
  };
};
